import { render, staticRenderFns } from "./PageGestionCompte.vue?vue&type=template&id=5d3cb96d&scoped=true"
import script from "./PageGestionCompte.vue?vue&type=script&lang=js"
export * from "./PageGestionCompte.vue?vue&type=script&lang=js"
import style0 from "./PageGestionCompte.vue?vue&type=style&index=0&id=5d3cb96d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3cb96d",
  null
  
)

export default component.exports